// Tiny clsx replacement to avoid adding a dependency.
type Val = string | number | false | null | undefined;
export default function clsx(...parts: Val[]): string {
  return parts.filter((p): p is string | number => Boolean(p)).join(" ");
}
